import { Component, OnInit, input, output, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { InputTypes } from "../../../locale/consts.en";
import { ControlType } from "./item.model";

@Component({
  selector: "app-item",
  templateUrl: "./item.component.html",
  styleUrls: ["./item.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ItemComponent implements OnInit {
  private fb = inject(FormBuilder);

  readonly itemForm = input<FormGroup>(undefined);
  readonly index = input<number>(undefined);
  readonly deleteItem = output<number>();

  inputTypes = InputTypes;
  FieldTypes = ControlType;
  addGroup: FormGroup;

  ngOnInit() {
    this.addGroup = this.fb.group({
      addValue: [""],
    });
  }

  getValues(form) {
    return form.get("values").controls;
  }

  delete() {
    this.deleteItem.emit(this.index());
  }

  addNewValue() {
    const val = this.addGroup.controls.addValue.value;
    if (val !== null) {
      const array = this.itemForm().controls.values as FormArray;
      array.push(new FormControl(val));
      this.addGroup.controls.addValue.setValue(null);
    }
  }

  deleteValue(index: number) {
    const array = this.itemForm().controls.values as FormArray;
    array.removeAt(index);
  }

  typeSelected(e: ControlType) {
    const array = this.itemForm().controls.values as FormArray;
    switch (+e as ControlType) {
      case ControlType.INTEGER:
      case ControlType.DECIMAL:
      case ControlType.TEXT:
      case ControlType.BOOLEAN:
      case ControlType.DEVICES:
      case ControlType.DATE:
      case ControlType.DATETIME:
      case ControlType.DATERANGE:
        array.clear();
        array.setValidators(null);
        break;
      default:
        array.setValidators(Validators.required);
    }
    array.updateValueAndValidity();
  }
}
